import React, { useState } from 'react';
import { Link } from '@tanstack/react-router';

import MemoryTimelineItem from './TimelineItem';

import type { Memory } from '../../types/memory';
import type { Timeline } from '../../types/timeline';

interface MemoryTimelineProps {
  memory?: Memory;
  timeline: Timeline;
  mode?: 'private' | 'public';
};

const MemoryTimeline: React.FC<MemoryTimelineProps> = ({ memory, timeline, mode }) => {
  const [expanded, setExpanded] = useState(false);
  const more = memory ? 0 : timeline.memories.length - 5;

  return (
    <div className="memory-timeline wa-stack wa-gap-2xs">
      <div className="page-eyebrow with-separator">
        {memory ? (
          'Timeline'
        ) : (
          <>
            <span>
              All Memories
            </span>
            <span>
              {timeline.memories.length} total
            </span>
          </>
        )}
      </div>
      <wa-card className="memory-timeline-card wa-stack wa-gap-2xs">
        {memory && (
          <div className="memory-timeline-header wa-cluster wa-gap-xs">
            <div className="memory-timeline-title">
              {timeline.dedicated_to}
            </div>
            <div className="memory-timeline-link">
              <Link to={`/timelines/${timeline.id}`}>
                View Timeline
              </Link>
            </div>
          </div>
        )}
        <div className="memory-timeline-line" />
        <div className="memory-timeline-memories wa-stack wa-gap-2xs">
          {timeline.memories.slice(0, more ? timeline.memories.length - more : timeline.memories.length).map((timelineMemory) => (
            <MemoryTimelineItem
              key={timelineMemory.id}
              timelineMemory={timelineMemory}
              memory={memory}
              timeline={timeline}
              mode={mode || (memory ? 'private' : 'public')}
            />
          ))}
          {more > 0 && (
            <>
              <div className={`memory-timeline-more wa-stack wa-gap-2xs ${expanded ? '' : 'hidden'}`}>
                {timeline.memories.slice(timeline.memories.length - more).map((timelineMemory) => (
                  <MemoryTimelineItem
                    key={timelineMemory.id}
                    timelineMemory={timelineMemory}
                    memory={memory}
                    timeline={timeline}
                    mode={memory ? 'private' : 'public'}
                  />
                ))}
              </div>
              <Link to="#" onClick={(e) => { e.preventDefault(); setExpanded(!expanded); }}>
                {expanded ? (
                  <div className="memory-timeline-more-show wa-cluster wa-gap-2xs">
                    <i className="fa-light fa-chevron-up" />
                    Hide {more} Memories
                  </div>
                ) : (
                  <div className="memory-timeline-more-hide wa-cluster wa-gap-2xs">
                    <i className="fa-light fa-chevron-down" />
                    Show {more} more
                  </div>
                )}
              </Link>
            </>
          )}
        </div>
      </wa-card>
    </div>
  );
}

export default MemoryTimeline;
